import { gql } from '@apollo/client'
import { scorecardData, commentaryData, oversData, liveInningData } from '@graphql/match'

export const FULL_SCOREBOARD = gql`
  query FetchLiveInningsData($input: liveInningsInput) {
    fetchLiveInningsData(input: $input) {
      ${scorecardData}
    }
  }
`

export const LIVE_INNING_DATA = gql`
  query FetchLiveInningsData($input: liveInningsInput) {
    fetchLiveInningsData(input: $input) {
      ${liveInningData}
    }
  }
`

export const MATCH_DETAIL = gql`
  query GetMatchById($input: oGetMatchByIdInput) {
    getMatchById(input: $input) {
      odds {
        allOdds {
          lay
          back
          title
        }
        favOdds {
          title
          lay
          back
        }
      }
      _id
      dEndDate
      bIsCommentary
      iEventId
      oWinPercent {
        sTitle
        sWinPercentage
      }
      oSeo {
        sSlug
        sTitle
        sRobots
        sDescription
        sCUrl
        oTwitter {
          sUrl
          sTitle
          sDescription
        }
        oFB {
          sUrl
          sTitle
          sDescription
        }
        eType
        eStatus
        aKeywords
        _id
        iId
      }
      sResult
      nLatestInningNumber
      sDescription
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      dStartDate
      oSeries {
        sAbbr
        sSeason
        sTitle
        sStatus
        nTotalTeams
        _id
        oSeo {
          sSlug
        }
        oCategory {
          oSeo {
            sSlug
          }
        }
      }
      oWinner {
        _id
      }
      sBallEvent
      #       oCricTezzScore {
      #         sFirstCircle
      #       }
      oTeamScoreA {
        sScoresFull
        sScores
        sOvers
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
        }
        oSeo {
          sSlug
        }
      }
      oVenue {
        sLocation
        sName
      }
      oToss {
        sText
        oWinnerTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
        }
        eDecision
      }
      oTeamScoreB {
        sScoresFull
        sScores
        sOvers
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
        }
        oSeo {
          sSlug
        }
      }
      oLiveScore {
        nRunrate
        sRequiredRunrate
      }
      aInning {
        sShortName
        nInningNumber
        oBattingTeam {
          sTitle
        }
        iBattingTeamId
      }
      oMom {
        sFullName
        sThumbUrl
        eTagStatus
        oImg {
          sAttribute
          sCaption
          sText
          sUrl
        }
        oSeo {
          sSlug
        }
      }
      oMos {
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
      }
      sUmpires
      sReferee
      oWeatherInfo {
        sUrl
        sWeatherTitle
        sWeatherDescription
        sTemperature
        sHumidity
        sVisibility
        sWindSpeed
        sClouds
      }
      oPitchInformation {
        sUrl
        sPitchCondition
        sBattingCondition
        sPaceBowlingCondition
        sSpineBowlingCondition
      }
    }
  }
`

export const FANTASY_TIPS_DETAILS = gql`
  query GetOverviewFront($input: oGetOverviewFrontInput) {
    getOverviewFront(input: $input) {
      aCricPrediction {
        _id
        ePlatformType
        oSeo {
          sSlug
        }
      }
      oTeam1 {
        aBenchedPlayers {
          sShortName
          sPlayingRole
          _id
        }
        oTeam {
          sTitle
        }
        aPlayers {
          sShortName
          sPlayingRole
          _id
        }
        iC
      }
      oTeam2 {
        oTeam {
          sTitle
        }
        aPlayers {
          sShortName
          sPlayingRole
          _id
        }
        iC
        aBenchedPlayers {
          _id
          sPlayingRole
          sShortName
        }
      }
      sMatchPreview
      sNews
      sPitchCondition
      sPitchReport
      sWeatherReport
      sWeatherCondition
      sAvgScore
    }
  }
`

export const GET_FANTASY_PLATFORM = gql`
  query GetFantasyTipsFront($input: oGetFantasyTipsFrontInput) {
    getFantasyTipsFront(input: $input) {
      _id
      oSeo {
        sSlug
      }
      oTeamB {
        sTitle
        _id
      }
      oTeamA {
        sTitle
        _id
      }
      dUpdated
      aLeague {
        aTeam {
          aSelectedPlayerFan {
            _id
            oTeam {
              sTitle
              _id
            }
            oPlayer {
              sFullName
              sFirstName
              sPlayingRole
              sShortName
            }
            nRating
            eRole
          }
          oTeamA {
            nCount
            oTeam {
              sAbbr
              sTitle
            }
          }
          oTeamB {
            nCount
            oTeam {
              sAbbr
              sTitle
            }
          }
          oCapFan {
            _id
          }
          oVCFan {
            _id
          }
          oTPFan {
            _id
          }
        }
        eLeague
      }
    }
  }
`

// export const GET_COMMENTARY = gql`
// query ListFinalMatchCommentaries($input: oListFinalMatchCommentaryFrontInput) {
//   listFinalMatchCommentaries(input: $input) {
//     ${commentaryData}
//   }
// }
// `

export const GET_COMMENTARY = gql`
query ListMatchCommentaries($input: oListMatchCommentaryFrontInput) {
  listMatchCommentaries(input: $input) {
    ${commentaryData}
  }
}
`

export const GET_MATCH_OVERVIEW = gql`
  query GetMatchOverviewFront($input: oGetMatchOverviewFrontInput!) {
    getMatchOverviewFront(input: $input) {
      aCricPrediction {
        ePlatformType
        oSeo {
          sSlug
        }
      }
      oTeam1 {
        aPlayers {
          bPlaying11
          bSubstitute
          oPlayer {
            eTagStatus
            sFullName
            sFirstName
            oSeo {
              sSlug
              eStatus
            }
          }
          sRoleStr
          isCaptain
          isWicketKeeper
        }
        oTeam {
          sTitle
        }
      }
      oTeam2 {
        aPlayers {
          bPlaying11
          bSubstitute
          oPlayer {
            eTagStatus
            sFullName
            sFirstName
            oSeo {
              sSlug
              eStatus
            }
          }
          sRoleStr
          isCaptain
          isWicketKeeper
        }
        oTeam {
          sTitle
        }
      }
      sMatchPreview
      sPitchCondition
      sWeatherReport
      sAvgScore
      oWinnerTeam {
        sTitle
      }
    }
  }
`

export const GET_MATCH_PLAYING_XI = gql`
  query GetMatchOverviewFront($input: oGetMatchOverviewFrontInput!) {
    getMatchOverviewFront(input: $input) {
      oTeam1 {
        aPlayers {
          bPlaying11
          bSubstitute
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oSeo {
              sSlug
            }
          }
          sRoleStr
        }
        oTeam {
          _id
          sAbbr
          sTitle
        }
      }
      oTeam2 {
        aPlayers {
          bPlaying11
          bSubstitute
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oSeo {
              sSlug
            }
          }
          sRoleStr
        }
        oTeam {
          _id
          sAbbr
          sTitle
        }
      }
    }
  }
`

export const GET_TEAM_FORM = gql`
  query GetTeamForm($input: getTeamFormInput) {
    getTeamForm(input: $input) {
      _id
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sResult
      sReferee
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      oSeo {
        sSlug
      }
      oTeamScoreA {
        oTeam {
          _id
          sTitle
          oImg {
            sAttribute
            sUrl
          }
          sAbbr
        }
        sOvers
        sScores
        sScoresFull
      }
      oWinner {
        _id
        sTitle
        sAbbr
        oImg {
          sText
          sCaption
          sAttribute
          sUrl
        }
      }
      oTeamScoreB {
        oTeam {
          _id
          oImg {
            sAttribute
            sUrl
          }
          sAbbr
          sTitle
        }
        sOvers
        sScores
        sScoresFull
      }
    }
  }
`
export const GET_HEAD_TO_HEAD = gql`
  query GetHeadToHead($input: getHeadToHeadInput) {
    getHeadToHead(input: $input) {
      sWinMargin
      sUmpires
      sTitle
      sSubtitle
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sResult
      oSeo {
        sSlug
      }
      sReferee
      sLiveMatchNote
      sLiveGameStatusStr
      oLiveGameStatus {
        sText
        sValue
      }
      sFormatStr
      oFormat {
        sText
        sValue
      }
      sEquation
      oWinner {
        sTitle
        sAbbr
        _id
      }
      oTeamScoreA {
        oTeam {
          sAbbr
          sTitle
        }
        sScores
        sScoresFull
        sOvers
      }
      oTeamScoreB {
        oTeam {
          sTitle
          sAbbr
        }
        sOvers
        sScores
        sScoresFull
      }
    }
  }
`

export const GET_MATCH_SQUAD = gql`
  query ListMatchSquad($input: oListMatchSquadInput) {
    listMatchSquad(input: $input) {
      bPlaying11
      iPlayerId
      oTeam {
        sAbbr
        sTitle
        _id
      }
      sName
      sRoleStr
    }
  }
`

export const RECENT_OVER = gql`
query ListMatchOvers($input: oListMatchOverFrontInput) {
  listMatchOvers(input: $input) {
    nTotal
    aResults {
      ${oversData}
    }
  }
}
`

export const GET_MATCH_STATS = gql`
  query GetMatchStatistics($input: getMatchStatisticsInput) {
    getMatchStatistics(input: $input) {
      sBalls
      bSuperOver
      aWorm {
        nOver
        nRuns
      }
      aPartnership {
        nBallFaced
        nRuns
        nOrder
        aBatsmen {
          oBatter {
            sShortName
          }
          nBallFaced
          nRuns
          nFours
          nSixes
        }
      }
      nInningNumber
      nRuns
      nWickets
      sName
      sOvers
      aFOWs {
        sOverDismissal
      }
      aManhattan {
        nRuns
        nOver
        nWickets
      }
      aRunRates {
        nRunRate
        nOver
      }
      aRunTypes {
        sValue
        sName
        sKey
      }
      aWickets {
        sValue
        sName
        sKey
      }
      aExtras {
        sValue
        sName
        sKey
      }
    }
  }
`

export const GET_PACE_SPIN = gql`
  query GetVenueStatsByMatchId($input: getVenueStatsByMatchIdInput) {
    getVenueStatsByMatchId(input: $input) {
      iVenueId
      nWicketsPace
      nWicketsSpin
    }
  }
`

export const GET_RECENT_MATCHES = gql`
  query GetVenueStatsByMatchId($input: getVenueStatsByMatchIdInput) {
    getVenueStatsByMatchId(input: $input) {
      aPreviousMatches {
        _id
        sSubtitle
        iWinnerId
        oTeamScoreA {
          iTeamId
          sScores
          sOvers
          oTeam {
            _id
            sCountryFull
            sCountry
            sAbbr
          }
        }
        oTeamScoreB {
          iTeamId
          sScores
          sOvers
          oTeam {
            _id
            sCountryFull
            sCountry
            sAbbr
          }
        }
        dStartDate
      }
    }
  }
`

export const GET_VENUE_STATS = gql`
  query GetVenueStatsByMatchId($input: getVenueStatsByMatchIdInput) {
    getVenueStatsByMatchId(input: $input) {
      aStatsPerInning {
        nInningNumber
        nAvgRuns
      }
      oHighestScore {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          oTeamScoreA {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
        }
      }
      oHighestScoreChased {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          oTeamScoreA {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
        }
      }
      oLowestScore {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          oTeamScoreA {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
        }
      }
      oLowestScoreDefended {
        iMatchId
        nScore
        nWickets
        oMatch {
          iWinnerId
          oTeamScoreA {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
          oTeamScoreB {
            iTeamId
            sOvers
            oTeam {
              sCountry
              sAbbr
            }
          }
        }
      }
      nTotalMatches
      nFirstBatWin
      nFirstBowlWin
    }
  }
`
export const GET_BATSMAN_STATS_SCORECARD = gql`
query GetPlayerMatchStats($input: getPlayerMatchStatsInput) {
  getPlayerMatchStats(input: $input) {
    oPlayerMatchStats {
      oPlayer {
        oImg {
          sUrl
        }
      }
      aStats {
        oBatStats {
          nFours
          nBalls
          nSixes
          aTimeline
          aRunsByBowlerType {
            nBalls
            nRuns
            sStrikeRate
            sType
            nSixes
          }
          aCommentaries { ${commentaryData} }
          nRuns
          oBattingMetrics {
            sBoundaryPercentage
            sBattingStyle
            nRunsRunning
            nRunsBoundary
            aPartnerships {
              iBatterId
              nBalls
              nRuns
              oBatter {
                sFullName
                _id
              }
            }
            aP2p {
              iBowlerId
              nBalls
              nRuns
              oBowler {
                _id
                sFirstName
              }
            }
          }
        }
        oBowlStats {
          aOvers {
            aEvents
            nRuns
            sOver
          }
        }
        nInningNumber
      }
      isDataFlag
    }
  }
}
`

export const GET_BOWLER_STATS_SCORECARD = gql`
query GetPlayerMatchStats($input: getPlayerMatchStatsInput) {
  getPlayerMatchStats(input: $input) {
    oPlayerMatchStats {
      oPlayer {
        oImg {
          sAttribute
          sUrl
        }
      }
      aStats {
        nInningNumber
        oBowlStats {
          aOvers {
            aEvents
            nRuns
            sOver
          }
        }
      }
      isDataFlag
    }
  }
}
`
